import BaseService from "@/js/core/BaseService";
import { LocationEndpoints } from "./LocationEndpoints";

export default class LocationService extends BaseService {
  async fetchLocations() {
    return this.api().get(LocationEndpoints.FetchLocations);
  }

	async fetchAllCountries() {
    return this.api().get(LocationEndpoints.FetchAllCountries);
  }
	async fetchAllCities(countryCode: string) {
    return this.api().get(`${LocationEndpoints.FetchAllCities}?countryCode=${countryCode}`);
  }
}
